<template>
    <div class='qrcode-panel'>
        <div class='qrcode-warpper'></div>
    </div>
</template>]
<script>
export default {
    name:'qrcode'
}
</script>

<style  rel="stylesheet/scss" lang="scss">
@import "../assets/sass/cmn.scss";
.qrcode-panel{
    position: absolute;
    top: 1000px;
    right: 50%;
    bottom: auto;
    margin-right: -760px; 
    .qrcode-warpper{
        width: 144px;
        height: 200px; 
         background: url(componentsImgPath('qrcode.png')) no-repeat;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/qrcode.vue